import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';
import { GurujiTabComponent } from './guruji-tab.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { DfpModule } from 'ngx-dfp';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { SharedModule } from 'src/app/shared/shared.module';
import { FavouriteComponent } from './favourite/favourite.component';
import { ExclusiveGuard } from 'src/app/core/guard/exclusive.guard';
import { GurujiCategoryComponent } from './guruji-category/guruji-category.component';

const routes: Routes = [
//   {
//     path: 'tab',
//     children: [
//         { path: ':name', component: GurujiTabComponent },
//     ]
// },
{ path: 'favourite', component: FavouriteComponent},
{ path: 'guruji-categories', component: GurujiCategoryComponent},
{ path: '', component: GurujiTabComponent,canActivate:[ExclusiveGuard] },
];

@NgModule({
  imports: [RouterModule.forChild(routes),
  ],
  exports: [RouterModule]
})
export class GurujiTabRoutingModule { }

